import React from 'react';
import { AlertCircle, User, Lock } from 'react-feather';

const Input = ({
  label,
  type,
  value,
  name,
  error,
  handleChange,
  placeholder,
  icon,
  disabled
}) => {
  return (
    <div className='form-group'>
      {label && (
        <label htmlFor={name} style={{ color: '#0678e6', fontWeight: 600 }}>
          {label}
        </label>
      )}
      <div className='input-container'>
        {icon && icon === 'User' && <User className='login-icon' size={21} />}
        {icon && icon === 'Lock' && <Lock className='login-icon' size={21} />}
        <input
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          type={type}
          placeholder={placeholder}
          className='form-control'
          disabled={disabled}
          autoComplete='off'
        />
      </div>
      {error && (
        <div className='alert alert-danger'>
          <AlertCircle size={14} /> {`  ${error}`}
        </div>
      )}
    </div>
  );
};

export default Input;
